<template>
  <div>
    <v-navigation-drawer app v-model="drawer" clipped dark>
      <v-container>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="title">
              Navigation lists
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>

        <v-list dence nav>
          <template v-for="nav in nav_list">
            <v-list-item
              v-if="!nav.lists"
              :to="nav.link"
              :key="nav.name"
              @click="submenu_close"
            >
              <v-list-item-icon>
                <v-icon>{{ nav.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>
                  {{ nav.name }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-group
              v-else
              :key="nav.name"
              :prepend-icon="nav.icon"
              no-action
              v-model="nav.active"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ nav.name }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                v-for="list in nav.lists"
                :key="list.name"
                :to="list.link"
                @click="drawer_close"
              >
                <v-list-item-title>
                  {{ list.name }}
                </v-list-item-title>
              </v-list-item>
            </v-list-group>
          </template>
        </v-list>
      </v-container>
    </v-navigation-drawer>

    <!-- 最上部のApp Bar -->
    <v-app-bar app clipped-left flat dark class="appBar">
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-col cols="4">
        <v-toolbar-title class="appBarTitle">
          <router-link to="/home/" style="color='white'">PortFolio</router-link>
        </v-toolbar-title>
      </v-col>
      <v-spacer></v-spacer>

      <v-toolbar-items v-for="nav in nav_list" :key="nav.name">
        <v-col cols="2" xs="1" sm="1">
          <v-btn
            text
            :to="nav.link"
            width="9em"
            v-if="!$vuetify.breakpoint.sm && !$vuetify.breakpoint.xs"
          >
            <v-icon class="ma-1">{{ nav.icon }}</v-icon>
            {{ nav.name }}
          </v-btn>
        </v-col>
      </v-toolbar-items>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  props: ["nav_list"],
  data() {
    return {
      drawer: false,
    };
  },
  methods: {
    // 全てのナビバーの子要素を閉じる
    submenu_close() {
      this.nav_list.forEach((nav) => {
        nav.active = false;
      });
      this.drawer_close();
    },
    drawer_close() {
      this.drawer = false;
    },
  },
  mounted() {
    this.drawer_close();
  },
};
</script>

<style scoped>
a:link,
a:visited,
a:hover,
a:active {
  color: white;
  text-decoration: none;
}
</style>